import { motion } from "framer-motion";
import TgStarIcon from "./Icons/TgStarIcon";
import { getRandomNumber } from "./Functions";

const FloatingIcons = () => {
  const getRandomSimilarColor = (baseColor) => {
    // Разбираем исходный цвет на R, G, B, A
    const [r, g, b, a] = baseColor.match(/\d+/g).map(Number);

    // Генерируем небольшие случайные отклонения (±20)
    const randomOffset = () => Math.floor(Math.random() * 71) - 35; // -20..+20

    const newR = Math.min(255, Math.max(0, r + randomOffset()));
    const newG = Math.min(255, Math.max(0, g + randomOffset()));
    const newB = Math.min(255, Math.max(0, b + randomOffset()));

    return `rgba(${newR}, ${newG}, ${newB}, ${a})`;
  };
  // Случайная позиция по горизонтали
  const getRandomLeft = () => {
    return `${getRandomNumber(5, 90)}%`;
  };

  return (
    <>
      {[...Array(15)].map((_, i) => (
        <motion.div
          key={i}
          initial={{
            opacity: 0,
            y: getRandomNumber(100, 0) + "px",
            left: getRandomLeft(),
          }}
          animate={{
            opacity: [0, 1, 1, 0],
            y: -50,
          }}
          transition={{
            duration: 3,
            ease: "linear",
            times: [0, 0.1, 0.9, 1],
            repeat: Infinity,
            repeatDelay: 5,
            delay: i * 0.5,
          }}
          style={{
            position: "absolute",
            bottom: 0,
            pointerEvents: "none",
          }}
        >
          <TgStarIcon
            size={getRandomNumber(16, 32) + "px"}
            color={getRandomSimilarColor("rgba(255, 231, 126, 1)")}
          ></TgStarIcon>
        </motion.div>
      ))}
    </>
  );
};

export default FloatingIcons;
